import { SVGProps } from 'react';

const SvgStethoscope = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 576 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M142.5 15.6c4.7 12.4-1.6 26.2-14 30.9L85.2 62.7c-3.1 1.2-5.2 4.2-5.2 7.5V200c0 57.4 46.6 104 104 104h16c57.4 0 104-46.6 104-104V70.2c0-3.3-2.1-6.3-5.2-7.5l-43.2-16.2c-12.4-4.7-18.7-18.5-14-30.9s18.5-18.7 30.9-14l43.2 16.2c21.8 8.1 36.3 29 36.3 52.4V200c0 78.5-59.5 143.1-135.8 151.1 3.7 63 55.9 112.9 119.8 112.9 66.3 0 120-53.7 120-120v-75.7c-32.5-10.2-56-40.5-56-76.3 0-44.2 35.8-80 80-80s80 35.8 80 80c0 35.8-23.5 66.1-56 76.3V344c0 92.8-75.2 168-168 168-90.4 0-164.1-71.4-167.8-160.8C91.7 343.3 32 278.6 32 200V70.2C32 46.9 46.5 26 68.3 17.8l43.3-16.3c12.4-4.7 26.2 1.6 30.9 14zM480 160a32 32 0 1 0 0 64 32 32 0 1 0 0-64z" />
  </svg>
);
export default SvgStethoscope;
